var _defs, _g;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgValid(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    id: "Group_86227",
    "data-name": "Group 86227",
    xmlns: "http://www.w3.org/2000/svg",
    xmlnsXlink: "http://www.w3.org/1999/xlink",
    width: 11.077,
    height: 8.419,
    viewBox: "0 0 11.077 8.419",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _defs || (_defs = /*#__PURE__*/React.createElement("defs", null, /*#__PURE__*/React.createElement("clipPath", {
    id: "clip-path"
  }, /*#__PURE__*/React.createElement("rect", {
    id: "Rectangle_25122",
    "data-name": "Rectangle 25122",
    width: 11.077,
    height: 8.419,
    fill: "#27c484"
  })))), _g || (_g = /*#__PURE__*/React.createElement("g", {
    id: "Group_86226",
    "data-name": "Group 86226",
    clipPath: "url(#clip-path)"
  }, /*#__PURE__*/React.createElement("path", {
    id: "Path_242487",
    "data-name": "Path 242487",
    d: "M4,8.181a1.244,1.244,0,0,1-.878-.365L.356,5.024A1.234,1.234,0,1,1,2.113,3.289L4.021,5.217,8.988.475a1.235,1.235,0,0,1,1.706,1.785L4.849,7.839A1.225,1.225,0,0,1,4,8.181Z",
    transform: "translate(0.001 0.238)",
    fill: "#27c484",
    fillRule: "evenodd"
  }))));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgValid);
export default __webpack_public_path__ + "static/media/Valid.cd66ff530b9534ae5c5bdba023106ace.svg";
export { ForwardRef as ReactComponent };